import { FC } from 'react';
import { Box, Divider, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { formatDate } from 'src/utils/format-date';
import { selectUserChoices } from 'src/store/slices/payment-plan-slice';
import { selectRoom } from 'src/store/slices/booking-slice';
import { theme } from 'src/styles/theme';
import { getStorage } from 'src/utils/local-storage-versioning';

import { styles } from './styles';

export const BookingDetailsContentShort: FC = () => {
    const { t } = useTranslation();
    const storage = getStorage();

    const { paymentPlanId = null } = storage.redirectState;

    const userChoices = useSelector(selectUserChoices);
    const roomData = useSelector(selectRoom);
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    if (!userChoices.term || !userChoices.numberOfStudents || !roomData) return null;

    const count = userChoices.term.duration;
    const bookingLength =
        roomData.monthly_price && !paymentPlanId
            ? t('booking_summary_months_count', { count })
            : t('booking_summary_weeks_count', { count });
    const startDate = formatDate(userChoices.term.startDate);
    const endDate = formatDate(userChoices.term.endDate);
    const studentCount = userChoices.numberOfStudents;
    const fontStyle = isSmallScreen ? 'h4' : 'h6';

    return (
        <Box css={!isSmallScreen && styles.bookingDetailsContainer}>
            {!isSmallScreen && <Divider css={styles.divider} />}
            <Box sx={styles.detailsRow}>
                <Box sx={styles.detailsColumnLeft}>
                    <Typography variant={fontStyle}>
                        {t('your_details_booking_students_count_long')}
                    </Typography>
                    <Typography variant={fontStyle}>{t('your_details_booking_length')}</Typography>
                    <Typography variant={fontStyle}>
                        {t('your_details_booking_start_date')}
                    </Typography>
                    <Typography variant={fontStyle}>
                        {t('your_details_booking_end_date')}
                    </Typography>
                </Box>
                <Box sx={styles.detailsColumnRight}>
                    <Typography variant={fontStyle}>{studentCount}</Typography>
                    <Typography variant={fontStyle}>{bookingLength}</Typography>
                    <Typography variant={fontStyle}>{startDate}</Typography>
                    <Typography variant={fontStyle}>{endDate}</Typography>
                </Box>
            </Box>
        </Box>
    );
};
